<rask-planera-search-results-header [arbetsorderList]="arbetsorderList" [selectedArbetsorderList]="selectedArbetsorderList"></rask-planera-search-results-header>
<rask-arbetsorder-list
    id="raskArbetsorderList"
    aid="rask-arbetsorder-list"
    [active]="active"
    [listHeight]="listHeight"
    [arbetsorderList]="arbetsorderList"
    [showOnlySelected]="showOnlySelected">
</rask-arbetsorder-list>